export default __webpack_public_path__ + "images/cf09ddfa75b9d64d6394715b8fc81516.svg";